module.exports = __webpack_public_path__ + "static/media/baylee-gramling-5m4Z14SDL80-unsplash.d781487c.jpg";